import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../api/axios';
import PayFrame from '../../components/PayFrame';
import { formatYmd } from '../../utils/paymentInfo';

// /odenis?t=<bilet> — lisenziyası bitmiş admin girişdə buraya gəlir (panel açılmır).
// Bilet 30 dəqiqəlikdir və yalnız ödəniş səhifəsini açır. Ödənişdən sonra yenidən daxil olmaq kifayətdir.
export default function PayTicket() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        const t = params.get('t') || '';
        api.get('/payment/ticket', { params: { t }, timeout: 20000 })
            .then((r) => setData(r.data))
            .catch((err) => setError(err.response?.data?.msg || 'Ödəniş səhifəsi alınmadı.'));
    }, [params]);

    const date = formatYmd(data?.license?.expiry);

    return (
        <div className="flex h-screen flex-col bg-gray-50">
            <div className="flex flex-wrap items-center justify-between gap-2 bg-rose-600 px-4 py-2.5 text-sm text-white">
                <span className="font-semibold">
                    Lisenziyanızın vaxtı bitib{date ? ` (${date})` : ''}.{data?.business_name ? ` ${data.business_name}` : ''}
                </span>
                <button type="button" onClick={() => navigate('/', { replace: true })}
                    className="rounded-lg bg-white/15 px-3 py-1 text-xs font-bold hover:bg-white/25">
                    Girişə qayıt
                </button>
            </div>
            <div className="min-h-0 flex-1 p-2 sm:p-4">
                {error ? (
                    <div className="flex h-full flex-col items-center justify-center gap-3 rounded-2xl border border-gray-200 bg-white p-6 text-center">
                        <p className="text-sm text-gray-600">{error}</p>
                        <button type="button" onClick={() => navigate('/', { replace: true })}
                            className="rounded-xl bg-gray-900 px-4 py-2 text-sm font-semibold text-white">Girişə qayıt</button>
                    </div>
                ) : (
                    <PayFrame url={data?.url} />
                )}
            </div>
        </div>
    );
}
